import { useTranslation } from 'react-i18next';
import reactStringReplace from 'react-string-replace';

export const useStringReplace = () => {
    const { t } = useTranslation();
    return (localizationKey: string, key: string, render: (index: number) => React.ReactNode) =>
        reactStringReplace(t(localizationKey, { [key]: `{{${key}}}` }), `{{${key}}}`, (_, i) => render(i));
};
